export function sanitizeString(input: string): string {
  if (!input || typeof input !== 'string') return '';
  const div = document.createElement('div');
  div.textContent = input;
  return div.innerHTML
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .slice(0, 500);
}

export function validateVesselName(name: string): string {
  const clean = sanitizeString(name).trim();
  if (!clean || clean.length < 2) throw new Error('Vessel name must be at least 2 characters');
  if (clean.length > 100) throw new Error('Vessel name too long (max 100)');
  return clean;
}

export function validateIMO(imo: string): string {
  const clean = sanitizeString(imo).replace(/\D/g, '');
  if (clean.length !== 7) throw new Error('IMO must be exactly 7 digits');
  // IMO checksum: multiply first 6 digits by [7,6,5,4,3,2], sum, mod 10
  const weights = [7, 6, 5, 4, 3, 2];
  let sum = 0;
  for (let i = 0; i < 6; i++) {
    sum += parseInt(clean[i]) * weights[i];
  }
  const checkDigit = sum % 10;
  if (parseInt(clean[6]) !== checkDigit) {
    throw new Error('Invalid IMO number (check digit failed)');
  }
  return clean;
}

export function validateLBP(lbp: number): number {
  if (typeof lbp !== 'number' || Number.isNaN(lbp)) throw new Error('LBP must be a number');
  if (lbp <= 0) throw new Error('LBP must be positive');
  if (lbp > 500) throw new Error('LBP seems too large (>500m)');
  return lbp;
}

export function validateDraft(val: number, name: string): number {
  return validateNumber(val, name, 0, 50);
}

export function validateDensity(val: number): number {
  return validateNumber(val, 'Density', 0.5, 2.0);
}

export function validateNumber(val: number, name: string, min?: number, max?: number): number {
  if (typeof val !== 'number' || Number.isNaN(val)) throw new Error(`${name} must be a valid number`);
  if (min !== undefined && val < min) throw new Error(`${name} must be >= ${min}`);
  if (max !== undefined && val > max) throw new Error(`${name} must be <= ${max}`);
  return val;
}
